// helpers
import { getUrl, ROUTES } from 'shared/api/urls';
import NFA from 'shared/helpers/analytics/NFAnalytics';
import { ApiHelper } from 'shared/helpers/api';
import { AuthAPI } from 'shared/api/authResolver';
import type { SaveProfilePayload, ProfileUser } from 'shared/api/profile';

export const generateOtp = (email: string) => {
  const body = { customer_email: email };
  return ApiHelper(getUrl(ROUTES.GENERATE_OTP), {
    method: 'POST',
    body,
    isBodyJSON: true,
  }).then((data: Response) => {
    if (data.status !== 200) {
      return Promise.reject(data.statusText);
    }
    return data.json();
  });
};

export const getProfileData = () => AuthAPI.getProfileData();

export const getProfileImage = (user?: ProfileUser) => AuthAPI.getProfileImage(user);

export const saveProfileData = (profileData: SaveProfilePayload) =>
  AuthAPI.saveProfileData(profileData);

export const GENDER_OPTIONS = [
  { label: 'Male', value: 'male' },
  { label: 'Female', value: 'female' },
  { label: 'Other', value: 'other' },
];

export const getImageFormat = (image: string) => {
  return image.includes('.svg') ? 'image/svg+xml' : 'image/jpeg';
};

export const onPageLoad = () => {
  NFA.firePageView();
};

export const getMaxDate = () => {
  const todayDate = new Date();

  const currFullYear = todayDate.getFullYear();
  const currMonth = String(todayDate.getMonth() + 1).padStart(2, '0');
  const currDate = String(todayDate.getDate()).padStart(2, '0');

  const maxDate = `${currFullYear}-${currMonth}-${currDate}`;
  return maxDate;
};
